import script from "./RecSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecSelect.vue?vue&type=style&index=0&id=3b068ae4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b068ae4"]])

export default __exports__